<script>
  import { performSearch } from '../search-module.js';
  import { facetValues, lastUpdatedFacet } from '../store.js';
  /** @type {{facet?: any}} */
  let { facet = $bindable({}) } = $props();

  let currentValues = $derived(facet.config.values);

  if (Array.isArray(facet.selectedValues)) {
    facet.selectedValues = facet.selectedValues[0] || null;
  }

  let selectedValue = $state(facet.selectedValues);
  let classes = $state('');

  // console.debug(facet.selectedValues);

  function updateClasses() {
    if (selectedValue === null) {
      classes = 'default-value';
    } else {
      classes = '';
    }
  }

  function update() {
    if (selectedValue === -1) {
      selectedValue = null;
    }

    updateClasses();

    facet.selectedValues = selectedValue;
    $facetValues = $facetValues;
    $lastUpdatedFacet = facet.name;

    // Debounce update submission
    // if (timeout) clearTimeout(timeout);
    // timeout = setTimeout(performSearch, 400);
    performSearch(1);
  }

  updateClasses();
</script>

{#if currentValues.length > 0}
  <fieldset class="facet-group is-open" data-search-module-facet={facet.config.name}>
    <!-- <FacetLabel {facet} /> -->

    <select
      class="facet-list {classes}"
      bind:value={selectedValue}
      onchange={update}
      name={facet.name}
    >
      <option value={null} selected={true} disabled>{facet.config.name}</option>
      <option value={-1}>&nbsp;</option>
      {#each currentValues as value (value.value)}
        <option value={value.value}>{value.Name || value.name} </option>
      {/each}
    </select>
  </fieldset>
{/if}
